import apiClient from './Api';
const PREFIX = '/inventory';

const getChartData = postData => {
  return apiClient({
    url: `${PREFIX}/getcount`,
    method: 'POST',
    data: postData
  });
};

const getTableData = postData => {
  return apiClient({
    url: `${PREFIX}/get`,
    method: 'POST',
    data: postData
  });
};

const reportInventory = postData => {
  return apiClient({
    url: `${PREFIX}/report`,
    method: 'POST',
    data: postData
  });
};

const vdsReport = postData => {
  return apiClient({
    url: `${PREFIX}/vdsreport`,
    method: 'POST',
    data: postData
  });
};

const sendIndividualAgeBucketReport = postData => {
  return apiClient({
    url: `${PREFIX}/sendindividualagebucketreport`,
    method: 'POST',
    data: postData
  });
};

const inventoryGallery = postData => {
  return apiClient({
    url: `${PREFIX}/gallery`,
    method: 'POST',
    data: postData
  });
};

const combineImagesWithBanner = postData => {
  return apiClient({
    url: `${PREFIX}/combineimageswithbanner`,
    method: 'POST',
    data: postData
  });
};

const removeBanner = postData => {
  return apiClient({
    url: `${PREFIX}/removebanner`,
    method: 'POST',
    data: postData
  });
};

const sendGroupReport = postData => {
  return apiClient({
    url: `${PREFIX}/groupreport`,
    method: 'POST',
    data: postData
  });
};

const sendVDSGroupReport = postData => {
  return apiClient({
    url: `${PREFIX}/vdsgroupreport`,
    method: 'POST',
    data: postData
  });
};

const sendAgeBucketReport = postData => {
  return apiClient({
    url: `${PREFIX}/agebucketreport`,
    method: 'POST',
    data: postData
  });
};

const downloadLibPhotos = postData => {
  return apiClient({
    url: `${PREFIX}/downloadlibphotos`,
    method: 'POST',
    data: postData,
    responseType: 'blob'
  });
};

const getDealerComparison = postData => {
  return apiClient({
    url: `${PREFIX}/getdealercomparison`,
    method: 'POST',
    data: postData,
    reqcancelToken: 'getDealerComparison'
  });
};

const generateSticker = postData => {
  return apiClient({
    url: `${PREFIX}/generatesticker`,
    method: 'POST',
    data: postData
  });
};

const vinDecode = postData => {
  return apiClient({
    url: `${PREFIX}/vindecode`,
    method: 'POST',
    data: postData
  });
};

const getBuyersGuideLink = postData => {
  return apiClient({
    url: `${PREFIX}/buyersguide`,
    method: 'POST',
    data: postData
  });
};

const addCustomComment = postData => {
  return apiClient({
    url: `${PREFIX}/customcomment`,
    method: 'POST',
    data: postData
  });
};

const getAiCustomCommentCount = postData => {
  return apiClient({
    url: `${PREFIX}/getaicommentcount`,
    method: 'POST',
    data: postData
  });
};

const getCustomWarrantyFormLink = postData => {
  return apiClient({
    url: `${PREFIX}/customwarrantyform`,
    method: 'POST',
    data: postData
  });
};

const searchInv = postData => {
  return apiClient({
    url: `${PREFIX}/search`,
    method: 'POST',
    data: postData
  });
};

const getInvStickerLogs = postData => {
  return apiClient({
    url: `${PREFIX}/getstickerlogs`,
    method: 'POST',
    data: postData
  });
};

const uploadRatingFile = postData => {
  return apiClient({
    url: `${PREFIX}/uploadratingfile`,
    method: 'POST',
    data: postData
  });
};

const getCustStickopt = postData => {
  return apiClient({
    url: `${PREFIX}/getcustomstickeropt`,
    method: 'POST',
    data: postData
  });
};

const getRatingData = () => {
  return apiClient({
    url: `${PREFIX}/getratingdata`,
    method: 'GET'
  });
};

const getVdpTrend = postData => {
  return apiClient({
    url: `${PREFIX}/getVdpTrend`,
    method: 'POST',
    data: postData
  });
};

const getInventoryDetails = postData => {
  return apiClient({
    url: `${PREFIX}/getInventoryDetails`,
    method: 'POST',
    data: postData
  });
};
const saveInvFeatures = postData => {
  return apiClient({
    url: `${PREFIX}/saveInvFeatures`,
    method: 'POST',
    data: postData
  });
};

const genarateAIFeatures = postData => {
  return apiClient({
    url: `${PREFIX}/genarateAIFeatures`,
    method: 'POST',
    data: postData
  });
};

const deleteVehicleVideo = postData => {
  return apiClient({
    url: `${PREFIX}/deleteVehicleVideo`,
    method: 'POST',
    data: postData
  });
};

const publishVideoOnYoutube = postData => {
  return apiClient({
    url: `${PREFIX}/publishVideoOnYoutube`,
    method: 'POST',
    data: postData
  });
};

const autoPublishOnYoutube = postData => {
  return apiClient({
    url: `${PREFIX}/autoPublishOnYoutube`,
    method: 'POST',
    data: postData
  });
};

const updateYoutubeVideo = postData => {
  return apiClient({
    url: `${PREFIX}/updateYoutubeVideo`,
    method: 'POST',
    data: postData
  });
};

const deleteYoutubeVideo = postData => {
  return apiClient({
    url: `${PREFIX}/deleteYoutubeVideo`,
    method: 'POST',
    data: postData
  });
};

const getDealerRating = postData => {
  return apiClient({
    url: `${PREFIX}/getdealerrating`,
    method: 'POST',
    data: postData
  });
};
const getInventoryAISummary = postData => {
  return apiClient({
    url: `${PREFIX}/generate-aisummary`,
    method: 'POST',
    data: postData
  });
};
const updateDealerInventoryAISummary = postData => {
  return apiClient({
    url: `${PREFIX}/update-aisummary`,
    method: 'POST',
    data: postData
  });
};
const saveInventoryAISummary = postData => {
  return apiClient({
    url: `${PREFIX}/save-aisummary`,
    method: 'POST',
    data: postData
  });
};

/* // NOT IN USE
const getBucketWidget = postData => {
  return apiClient({
    url: `${PREFIX}/getbucket`,
    method: 'POST',
    data: postData
  });
};
const downloadInventory = postData => {
  return apiClient({
    url: `${PREFIX}/download`,
    method: 'POST',
    responseType: 'blob',
    data: postData
  });
};
const downloadDealerComparison = postData => {
  return apiClient({
    url: `${PREFIX}/downloaddealercomparison`,
    method: 'POST',
    data: postData,
    responseType: 'blob'
  });
};
*/

const InventoryService = {
  addCustomComment,
  getAiCustomCommentCount,
  vinDecode,
  getBuyersGuideLink,
  getCustomWarrantyFormLink,
  generateSticker,
  sendAgeBucketReport,
  getDealerComparison,
  downloadLibPhotos,
  sendGroupReport,
  sendVDSGroupReport,
  getTableData,
  getChartData,

  inventoryGallery,
  reportInventory,
  vdsReport,
  searchInv,
  getInvStickerLogs,
  uploadRatingFile,
  getCustStickopt,
  getRatingData,
  getVdpTrend,
  getInventoryDetails,
  saveInvFeatures,
  genarateAIFeatures,
  deleteVehicleVideo,
  publishVideoOnYoutube,
  autoPublishOnYoutube,
  updateYoutubeVideo,
  deleteYoutubeVideo,
  getDealerRating,
  // getBucketWidget,
  // downloadDealerComparison,
  // downloadInventory,
  combineImagesWithBanner,
  removeBanner,
  getInventoryAISummary,
  saveInventoryAISummary,
  updateDealerInventoryAISummary,
  sendIndividualAgeBucketReport
};

export default InventoryService;
